import Drawer from "@components/shared/Drawer";
import UserAPI from "@network/api/user";
import { AwesomeTableComponent, InputTextSearch, Modal } from "d-react-components";
import { debounce } from "lodash";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function UserDetailChannelUpdateModal({ open, onClose, title, type, userId, onSave }: any) {
  const { t } = useTranslation();
  const tableRef = useRef<any>();
  const textSearch = useRef();
  const [channelSelecting, setChannelSelecting] = useState<any>([]);

  const columns = [
    {
      title: t("name"),
      dataIndex: "name",
      render: (name: any, channel: any) => (
        <a href={channel?.editurl} target="_blank">
          {name}
        </a>
      ),
    },
    {
      title: t("code"),
      dataIndex: "code",
    },
  ];

  const onChangeText = debounce((text) => {
    textSearch.current = text;
    tableRef.current.refresh();
  }, 500);

  const source = (paging: any) => {
    const body = { id: userId, action: type, search: textSearch.current };
    return UserAPI.channelList(body, paging);
  };

  const transformer = (res: any) => {
    return res?.data?.data?.channels ?? [];
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={title}
      onSave={() => onSave(channelSelecting)}
      size="auto"
      width={"600px"}
    >
      <div>
        <InputTextSearch
          onChange={(event: any) => onChangeText(event.target.value)}
        />
        <AwesomeTableComponent
          ref={(ref) => {
            tableRef.current = ref;
          }}
          columns={columns}
          source={source}
          transformer={transformer}
          className="mt-3"
          rowSelection={{
            onChange: (selectedRowKeys, selectedRows) => {
              setChannelSelecting(selectedRows);
            },
            preserveSelectedRowKeys: true,
          }}
        />
      </div>
    </Drawer>
  );
}

export default UserDetailChannelUpdateModal;
